import React, { useEffect, useRef } from "react"
import L from "leaflet"
import "leaflet-plugins/layer/tile/Yandex"
import "leaflet/dist/leaflet.css"
import "leaflet.markercluster/dist/leaflet.markercluster"
import "leaflet.markercluster/dist/MarkerCluster.css"
import "leaflet.markercluster/dist/MarkerCluster.Default.css"
// import "./style.css"
import "leaflet-routing-machine/dist/leaflet-routing-machine"
import "leaflet-routing-machine/dist/leaflet-routing-machine.css"
import "leaflet-control-geocoder/dist/Control.Geocoder"
import "leaflet-control-geocoder/dist/Control.Geocoder.css"

delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("../../assets/icons/marker.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
})

const Map = ({ coordinates = [], setMapContainer }) => {
  const mapRef = useRef(null)
  useEffect(() => {
    const container = L.DomUtil.get(mapRef?.current)
    const map = L.map(container, {
      center: [40.3734, 71.7978],
      zoom: 8,
      zoomControl: false,
      minZoom: 3,
    })

    // const yndx = new L.Yandex()

    const yndx = L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 19,
      className: "map-tiles",
    }).addTo(map)

    map.addLayer(yndx)
    setMapContainer(map)
    // const routes = L.Routing.control({
    //   waypoints: coordinates?.map((item) => L.latLng(item.lat, item.lng)),
    //   geocoder: L.Control.Geocoder.nominatim(),
    //   collapsible: true,
    //   // plan: L.Routing.plan(
    //   //   coordinates.map((item) => L.latLng(item.lat, item.lng))
    //   // ),

    //   router: L.Routing.osrmv1({
    //     serviceUrl: "https://m.infomap.uz/route/v1",
    //   }),
    //   show: false,
    //   showAlternatives: true,
    //   addWaypoints: false,
    //   routeWhileDragging: false,
    //   // draggableWaypoints: false,
    //   lineOptions: {
    //     styles: [
    //       {
    //         color: "#20ae84",
    //         // className: "animate"
    //       },
    //     ],
    //   },
    // }).addTo(map)
    // routes.on("routesfound", function (e) {
    //   const routes = e.routes
    //   const summary = routes[0].summary
    //   const h = Math.floor(summary.totalTime / 3600)
    //   const m = Math.floor((summary.totalTime % 3600) / 60)
    //   const distance = Number(summary.totalDistance / 1000).toFixed(2)
    // })
    return () => {
      map.off()
      map.remove()
    }
  }, [coordinates])

  return (
    <>
      <div
        ref={mapRef}
        className="custom-popup"
        id="map"
        style={{
          width: "100%",
          height: "calc(100vh - 85px)",
        }}
      />
    </>
  )
}

export default Map
